module.exports = __webpack_public_path__ + "img/fast-splitter-south.df267fe1.png";